import { render, staticRenderFns } from "./DeviceImage.vue?vue&type=template&id=5d5e80f0"
import script from "./DeviceImage.vue?vue&type=script&lang=js"
export * from "./DeviceImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports